import { render, staticRenderFns } from "./Informacion.vue?vue&type=template&id=3eaa9469&scoped=true"
import script from "./Informacion.vue?vue&type=script&lang=js"
export * from "./Informacion.vue?vue&type=script&lang=js"
import style0 from "./Informacion.vue?vue&type=style&index=0&id=3eaa9469&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaa9469",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eaa9469')) {
      api.createRecord('3eaa9469', component.options)
    } else {
      api.reload('3eaa9469', component.options)
    }
    module.hot.accept("./Informacion.vue?vue&type=template&id=3eaa9469&scoped=true", function () {
      api.rerender('3eaa9469', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/unidad-compuesta/Informacion.vue"
export default component.exports